// extracted by mini-css-extract-plugin
export default {"form":"TaskForm_form__8Rqcn","input_container":"TaskForm_input_container__YzErq"};